import axios from 'axios'
import HTTP from './http'

export default {
    getList: payload => axios.get(HTTP.TERMS_LIST, { params: payload }),
    addTerm: payload => axios.post(HTTP.TERM, payload),
    updateTerm: payload => axios.put(HTTP.TERM, payload),
    deleteTerm: payload => axios.delete(HTTP.TERM, { params: { payload } }),
    deleteFromCollection: payload => axios.delete(HTTP.TERM_FROM_COLLECTION, { params: { ...payload } })
}
